import YCombinator from "assets/homepage/aboutus/investors/organizations/YCombinator.svg";
import HustleFund from "assets/homepage/aboutus/investors/organizations/HustleFund.svg";
import Charge from "assets/homepage/aboutus/investors/organizations/Charge.svg";
import TigerGlobal from "assets/homepage/aboutus/investors/organizations/TigerGlobal.svg";
import SomaCapital from "assets/homepage/aboutus/investors/organizations/SomaCapital.svg";
import AlumniVentures from "assets/homepage/aboutus/investors/organizations/AlumniVentures.svg";

import JasonWarnerLogo from "assets/homepage/aboutus/investors/individuals/jason-warner.jpg";
import GuypoLogo from "assets/homepage/aboutus/investors/individuals/guy-podjarny.jpg";
import JoeTeplowLogo from "assets/homepage/aboutus/investors/individuals/joe-teplow.jpg";
import EugeneYanLogo from "assets/homepage/aboutus/investors/individuals/eugene-yan.png";
import AndreasLogo from "assets/homepage/aboutus/investors/individuals/andreas-klinger.jpeg";
import EdLandoLogo from "assets/homepage/aboutus/investors/individuals/ed-lando.jpg";
import TaimurLogo from "assets/homepage/aboutus/investors/individuals/taimur-rashid.jpg";
import IheanyiLogo from "assets/homepage/aboutus/investors/individuals/iheanyi.jpg";
import TeddyLogo from "assets/homepage/aboutus/investors/individuals/teddy.jpg";
import SalilLogo from "assets/homepage/aboutus/investors/individuals/salil.jpg";
import SavinLogo from "assets/homepage/aboutus/investors/individuals/savin.jpg";
import DanielLogo from "assets/homepage/aboutus/investors/individuals/daniel-wolfson.jpg";
import MattLogo from "assets/homepage/aboutus/investors/individuals/matt-robinson.jpeg";
import JoshuaLogo from "assets/homepage/aboutus/investors/individuals/joshua-schachter.jpg";
import JonLogo from "assets/homepage/aboutus/investors/individuals/jon-runyan.jpg";
import StephanieLogo from "assets/homepage/aboutus/investors/individuals/stephanie-sher.jpeg";
import IvanLogo from "assets/homepage/aboutus/investors/individuals/ivan.jpeg";
import RayLogo from "assets/homepage/aboutus/investors/individuals/ray-colletti.jpeg";
import AdamLogo from "assets/homepage/aboutus/investors/individuals/adam-stokar.png";
import DavidLogo from "assets/homepage/aboutus/investors/individuals/david-mehlman.jpeg";

export const Organizations = [
  {
    src: YCombinator,
    alt: "Y Combinator"
  },
  {
    src: TigerGlobal,
    alt: "Tiger Global"
  },
  {
    src: Charge,
    alt: "Charge Ventures"
  },
  {
    src: HustleFund,
    alt: "Hustle Fund"
  },
  {
    src: SomaCapital,
    alt: "Soma Capital"
  },
  {
    src: AlumniVentures,
    alt: "Alumni Ventures"
  }
];

export const Individuals = [
  {
    avatar: GuypoLogo,
    name: "Guy Podjarny",
    position: "Founder of Snyk"
  },
  {
    avatar: JasonWarnerLogo,
    name: "Jason Warner",
    position: "CTO of GitHub"
  },
  {
    avatar: EugeneYanLogo,
    name: "Eugene Yan",
    position: "Scientist at Amazon"
  },
  {
    avatar: TaimurLogo,
    name: "Taimur Rashid",
    position: "CBO at Redis"
  },
  {
    avatar: JoeTeplowLogo,
    name: "Joe Teplow",
    position: "Founder of Rebel"
  },
  {
    avatar: AndreasLogo,
    name: "Andreas Klinger",
    position: "Remote First Capital"
  },
  {
    avatar: StephanieLogo,
    name: "Stephanie Sher",
    position: "Full Stack Deep Learning"
  },
  {
    avatar: EdLandoLogo,
    name: "Edward Lando",
    position: "Pareto Holdings"
  },
  // {
  //   avatar: IheanyiLogo,
  //   name: "Iheanyi Ekechukwu",
  //   position: "Engineer at PlanetScale"
  // },
  {
    avatar: JonLogo,
    name: "Jon Runyan",
    position: "General Counsel at Okta"
  },
  {
    avatar: JoshuaLogo,
    name: "Joshua Schachter",
    position: "Founder of Delicious"
  },
  {
    avatar: SalilLogo,
    name: "Salil Deshpande",
    position: "Uncorrelated Ventures"
  },
  {
    avatar: DanielLogo,
    name: "Daniel Wolfson",
    position: "Oldslip Group"
  },
  {
    avatar: MattLogo,
    name: "Matt Robinson",
    position: "Founder of GoCardless"
  },
  {
    avatar: SavinLogo,
    name: "Savin Goyal",
    position: "Outerbounds CTO"
  },
  // {
  //   avatar: TeddyLogo,
  //   name: "Teddy Citrin",
  //   position: "Definition Capital"
  // },
  {
    avatar: IvanLogo,
    name: "Ivan Kirigin",
    position: "Tango.vc"
  }
  // {
  //   avatar: RayLogo,
  //   name: "Ray Colletti",
  //   position: "Zag Capital"
  // },
  // {
  //   avatar: AdamLogo,
  //   name: "Adam Stokar",
  //   position: "Founder of ClubOS"
  // },
  // {
  //   avatar: DavidLogo,
  //   name: "David Mehlman",
  //   position: "Areca Holdings"
  // }
];
